var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketingIcnRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3974_2569",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#e33745"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3974_2569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8269 12.7497V11.2497H19.4421V12.7497H15.8269ZM16.9691 19.4805L14.0769 17.3112L14.9884 16.1152L17.8806 18.2842L16.9691 19.4805ZM14.9499 7.84597L14.0384 6.64972L16.9306 4.48047L17.8421 5.67672L14.9499 7.84597ZM3.55762 14.4997V9.49972H7.26912L11.5576 5.21147V18.788L7.26912 14.4997H3.55762ZM10.0576 8.84972L7.90762 10.9997H5.05762V12.9997H7.90762L10.0576 15.1497V8.84972Z",
    fill: "#e33745"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingIcnRed);
export default __webpack_public_path__ + "static/media/marketingIcnRed.7ebd6e7e82e2dd3accdee5c0c31d3f7f.svg";
export { ForwardRef as ReactComponent };